import { render, staticRenderFns } from "./Inbox.vue?vue&type=template&id=ceeaaaa2&scoped=true"
import script from "./Inbox.vue?vue&type=script&lang=js"
export * from "./Inbox.vue?vue&type=script&lang=js"
import style0 from "./Inbox.vue?vue&type=style&index=0&id=ceeaaaa2&prod&scoped=true&lang=css"
import style1 from "./Inbox.vue?vue&type=style&index=1&id=ceeaaaa2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceeaaaa2",
  null
  
)

export default component.exports